import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "../../myfin_v2/elements/Modal";
import { Button } from "../../myfin_v2/elements/Button";

import commoncss from "../../myfin_v2/css/common.module.css";
import libcss from "../../myfin_v2/css/library.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg";

const AddEditSignatory = ({ setShowAddEditSignatoryModal, formData, setFormData, onSave }) => {
  const [selectedRole, setSelectedRole] = useState(formData?.category || "auditor");
  const [isAuditorDatePickerOpen, setIsAuditorDatePickerOpen] = useState(false);
  const [isBODDatePickerOpen, setIsBODDatePickerOpen] = useState(false);

  useEffect(() => {
  if (formData?.category) {
    setSelectedRole(formData.category);
  } else {
    setSelectedRole("auditor");
    setFormData((prev) => ({ ...prev, category: "auditor" }));
  }
}, [formData?.category]);


  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };


  return (
    <Modal
      width="50%"
      // minHeight="500px"
      title={`${formData?._id? "Edit":"Add"} Signatory`}
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon className={commoncss.clickable} onClick={() => setShowAddEditSignatoryModal(false)} />
      }
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={() => setShowAddEditSignatoryModal(false)}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label={`${formData?._id? "Edit":"Add"} Signatory`}
            onClick={() => {
              onSave(formData);
            }}
          />
        </>
      }
    >
      <div style={{ padding: "10px 30px" }}>
        <div className={adminPortalCss.radioButtonSection} style={{ paddingLeft: "5px" }}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="role"
            value={selectedRole}
            onChange={(e) => {setSelectedRole(e.target.value);handleChange("category", e.target.value)}}
            className={adminPortalCss.radioSection}
          >
            <FormControlLabel
              value="auditor"
              className={commoncss.radioDiv}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                />
              }
              label="Auditor"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
            <FormControlLabel
              className={commoncss.radioDiv}
              value="board of directors"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                />
              }
              label="Board of Directors"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
          </RadioGroup>
        </div>
        {selectedRole === "auditor" && (
          <div className={`my-3`}>
            <InputGroup
              label="Firm Name"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.firmName || ""}
                    onChange={(e) => handleChange("firmName", e.target.value)}
                    placeholder="Enter Firm Name"
                  />
                </>,
              ]}
            />
            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Role"
                      inputs={[
                        <input
                          type="text"
                          value={formData.firmRole || ""}
                          onChange={(e) =>
                            handleChange("firmRole", e.target.value)
                          }
                          placeholder="Enter Role"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Firm Number"
                      inputs={[
                        <input
                          type="text"
                          value={formData.firmNumber || ""}
                          onChange={(e) =>
                            handleChange("firmNumber", e.target.value)
                          }
                          placeholder="Enter Firm Number"
                        />,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>
            <InputGroup
              label="Auditor Name"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.auditorName || ""}
                    onChange={(e) =>
                      handleChange("auditorName", e.target.value)
                    }
                    placeholder="Enter Auditor Name"
                  />
                </>,
              ]}
            />

            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Auditor Role"
                      inputs={[
                        <input
                          type="text"
                          value={formData.auditorRole || ""}
                          onChange={(e) =>
                            handleChange("auditorRole", e.target.value)
                          }
                          placeholder="Enter Auditor Role"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Membership Number"
                      inputs={[
                        <input
                          type="text"
                          value={formData.membershipNumber || ""}
                          onChange={(e) =>
                            handleChange("membershipNumber", e.target.value)
                          }
                          placeholder="Enter Membership Number"
                        />,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>

            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Place"
                      inputs={[
                        <input
                          type="text"
                          value={formData.place || ""}
                          onChange={(e) =>
                            handleChange("place", e.target.value)
                          }
                          placeholder="Enter Place"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Date"
                      inputs={[
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDatePicker
                            open={isAuditorDatePickerOpen}
                            onOpen={() => setIsAuditorDatePickerOpen(true)}
                            onClose={() => setIsAuditorDatePickerOpen(false)}
                            value={formData.date ? dayjs(formData.date, "DD/MM/YYYY") : null}
                            onChange={(e) => {
                              handleChange("date", e ? e.format("DD/MM/YYYY") : "");
                            }}
                            slots={{
                              field: (props) => (
                                <div style={{ position: "relative", width: "100%" }} onClick={() => setIsAuditorDatePickerOpen(true)}>
                                  <input
                                    type="text"
                                    value={formData.date || ""}
                                    readOnly
                                    placeholder="Enter Date"
                                    style={{ cursor: "pointer", paddingRight: "40px" }}
                                  />
                                  <CalenderIcon 
                                    width={20} 
                                    height={20} 
                                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }} 
                                    onClick={(e) => { e.stopPropagation(); setIsAuditorDatePickerOpen(true); }} 
                                  />
                                </div>
                              )
                            }}
                          />
                        </LocalizationProvider>,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>
          </div>
        )}
        {selectedRole === "board of directors" && (
          
          <div className={`my-3`}>
            <InputGroup
              label="Name"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.directorName || ""}
                    onChange={(e) => handleChange("directorName", e.target.value)}
                    placeholder="Enter Name"
                  />
                </>,
              ]}
            />
            
            <InputGroup
              label="Role"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.directorRole || ""}
                    onChange={(e) =>
                      handleChange("directorRole", e.target.value)
                    }
                    placeholder="Enter Role"
                  />
                </>,
              ]}
            />

            <InputGroup
              label="Number"
              inputs={[
                <>
                  <input
                    type="text"
                    value={formData.directorNumber || ""}
                    onChange={(e) =>
                      handleChange("directorNumber", e.target.value)
                    }
                    placeholder="Enter Number"
                  />
                </>,
              ]}
            />

            <div>
              <InputGroup
                inputs={[
                  <>
                    <InputGroup
                      label="Place"
                      inputs={[
                        <input
                          type="text"
                          value={formData.place || ""}
                          onChange={(e) =>
                            handleChange("place", e.target.value)
                          }
                          placeholder="Enter Place"
                        />,
                      ]}
                    />
                  </>,
                  <>
                    <InputGroup
                      label="Date"
                      inputs={[
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDatePicker
                            open={isBODDatePickerOpen}
                            onOpen={() => setIsBODDatePickerOpen(true)}
                            onClose={() => setIsBODDatePickerOpen(false)}
                            value={formData.date ? dayjs(formData.date, "DD/MM/YYYY") : null}
                            onChange={(e) => {
                              handleChange("date", e ? e.format("DD/MM/YYYY") : "");
                            }}
                            slots={{
                              field: (props) => (
                                <div style={{ position: "relative", width: "100%" }} onClick={() => setIsBODDatePickerOpen(true)}>
                                  <input
                                    type="text"
                                    value={formData.date || ""}
                                    readOnly
                                    placeholder="Enter Date"
                                    style={{ cursor: "pointer", paddingRight: "40px" }}
                                  />
                                  <CalenderIcon 
                                    width={20} 
                                    height={20} 
                                    style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", cursor: "pointer" }} 
                                    onClick={(e) => { e.stopPropagation(); setIsBODDatePickerOpen(true); }} 
                                  />
                                </div>
                              )
                            }}
                          />
                        </LocalizationProvider>,
                      ]}
                    />
                  </>,
                ]}
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AddEditSignatory;
